module.exports = __webpack_public_path__ + "img/UploadSimple.61bff630.svg";